<!--
 * @Author: your name
 * @Date: 2021-07-21 10:24:25
 * @LastEditTime: 2021-07-31 15:28:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hpss-ui\src\views\crmedical\value\valueDeclare.vue
-->
<template>
    <div id='vauleDeclare' v-loading="onloading">
        <el-steps :active="stepsActive" align-center>
            <el-step title=" 基础信息"></el-step>
            <el-step title="后勤价值年度目标"></el-step>
            <el-step title="后勤管理边界"></el-step>
            <el-step title="后勤组织架构设计与职责分工"></el-step>
            <el-step title="后勤绩效考核及评价机制设计"></el-step>
            <el-step title="关于后勤价值型管理的补充建议"></el-step>
        </el-steps>
        <declareBaseInfo ref='BaseInfoRef' :editDetailInfo='editDetailInfo' v-show="stepsActive==0" />
        <valueTarget ref='valueTargetRef' :editDetailInfo='editDetailInfo' v-show="stepsActive==1"/>
        <logistics-management-boundary ref='boundaryRef' :editDetailInfo='editDetailInfo' v-show="stepsActive==2"/>
        <logisticsDesgin ref='DesginRef' :editDetailInfo='editDetailInfo' v-show="stepsActive==3" />
        <logisticsAchievements ref='AchievementRef' :editDetailInfo='editDetailInfo' v-show="stepsActive==4"/>
        <valueSupple ref='SuppleRef'  :editDetailInfo='editDetailInfo' v-show="stepsActive==5"/>
         <div class="activeBtnArea">
            <el-button style="margin-top: 12px;" @click="preview" :disabled="previewBtnShow" >预览</el-button>
            <el-button style="margin-top: 12px;" @click="save">保存</el-button>
            <el-button style="margin-top: 12px;" @click="last" v-show="stepsActive!=0">上一步</el-button>
            <el-button style="margin-top: 12px;" @click="next" v-show="stepsActive!=5">下一步</el-button>
            <el-button style="margin-top: 12px;" @click="save1" v-show="stepsActive==5">提交</el-button>
        </div>
    </div>
</template>
<script>
import urlSettings from '@/config/url-settings.js';
import declareBaseInfo from './valuedeclare/declareBaseInfo';
import valueTarget from './valuedeclare/valueTarget';
import logisticsManagementBoundary from './valuedeclare/logisticsManagementBoundary';
import logisticsDesgin from './valuedeclare/logisticsDesgin';
import logisticsAchievements from './valuedeclare/logisticsAchievements';
import valueSupple from './valuedeclare/valueSupple';
export default {
  created() {
    console.log('declare', this.editDetailInfo);
  },
  props: {
    editDetailInfo: {},
  },
  data() {
    return {
      previewBtnShow:false,
      onloading: false,
      stepsActive: 0,
      statusOption: [
        'BaseInfoRef',
        'valueTargetRef',
        'boundaryRef',
        'DesginRef',
        'AchievementRef',
        'SuppleRef',
      ],
      stepFlag: false,
      submitType:0
    };
  },
  components: {
    declareBaseInfo,
    valueTarget,
    logisticsManagementBoundary,
    logisticsDesgin,
    logisticsAchievements,
    valueSupple,
  },
  watch:{
    editDetailInfo:()=>{
      this.previewBtnShow = false
    }
  },
  methods: {
    next(flag) {
      this.save().then((res) => {
        console.log('next',this.stepFlag)
        if (this.stepFlag) {
          if (this.stepsActive++ > 4) {
            this.stepsActive = 0;
            this.stepFlag = false;
          }
        }
      });
      
    },
    last() {
      this.save().then((res) => {
        console.log('last',this.stepFlag)
        if (this.stepFlag) {
          if (this.stepsActive-- < 1) {
            this.stepsActive = 0;
            this.stepFlag = false;
          }
        }
      });
    },
    //提交
    async save1() {
      this.onloading = true
      let refObj = this.statusOption[this.stepsActive];
      await this.$refs[refObj].submit1().then((res) => {
        this.stepFlag = res;
        this.onloading = false
      }).catch((res)=>{
        this.onloading = false
      });
    },
    //保存
    async save() {
      this.onloading = true
      let refObj = this.statusOption[this.stepsActive];
      await this.$refs[refObj].submit().then((res) => {
        this.stepFlag = res;
        this.onloading = false
      }).catch((res)=>{
        this.onloading = false
      });
    },
    preview() {
      if(this.editDetailInfo.id){
        this.$emit('preview',this.editDetailInfo.id)
      }else{
        this.$message({
          showClose: true,
          message: '请将数据填写完整保存后查看',
          type: 'error',
        });
      }
        
    },
  },
};
</script>
<style scoped >
.activeBtnArea {
  display: flex;
  justify-content: flex-end;
  margin-right: 40px;
  margin-bottom: 60px;
  margin-top: 40px;
}
</style>
<style>
#vauleDeclare .el-step__icon.is-text {
  height: 30px;
  width: 30px;
}
#vauleDeclare .el-step__title.is-wait {
  /* padding: 0 40px; */
}
</style>



